import { ThumbUpIcon, UserAddIcon, StarIcon, ArrowRightIcon, DocumentSearchIcon, LockClosedIcon, PhoneIcon, PhoneIncomingIcon, PuzzleIcon } from '@heroicons/react/outline';
import TaxReliefLongForm from './Calculator/TaxReliefLongForm';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import Calculator from './TAA/Calculator';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';



function LandingPageFour(props) {



    return (
        <div>

            {/* Hero Section */}

            <header className="bg-gray-600 banner px-4 py-6 md:py-20">
                <div className="max-w-6xl mx-auto text-center">

                    <span className="inline-block bg-red-600 text-white text-sm font-bold uppercase tracking-wide px-4 py-2 rounded-full">
                        Speak With a Tax Specialist Today
                    </span>

                    <h1 className="mt-6 text-white text-4xl md:text-7xl font-extrabold leading-tight">
                        Owe the IRS
                        <span className="block text-yellow-400">$10,000 or More?</span>
                    </h1>

                    <h2 className="mt-5 text-white text-2xl md:text-4xl font-semibold">
                        Call Now for a Free Tax Relief Consultation
                    </h2>

                     <div className="mt-6">
                        <a
                            href="tel:800-730-6512"
                            className="inline-flex items-center justify-center bg-green-500 hover:bg-green-700 text-white text-xl md:text-2xl font-bold px-10 py-5 rounded-xl shadow-xl transition"
                        >
                            📞 Call (800) 730-6512
                        </a>

                        <p className="mt-3 text-white font-medium">
                            Free Consultation • No Obligation • Speak With a Specialist Now
                        </p>
                    </div>

                    <p className="mt-6 max-w-3xl mx-auto text-lg md:text-xl text-gray-100">
                        Our experienced tax resolution team may be able to help stop IRS collections,
                        reduce penalties, and explain your available relief options. Call now to speak
                        directly with a specialist and find out if you qualify.
                    </p>

                   

                </div>
            </header>

            {/* Main Content */}
            <main>

                {/* <section className='py-10 px-5'>
                    <div className='max-w-7xl mx-auto'>
                        <p className='text-2xl md:text-3xl mb-5'><b>Step 1:</b> Begin the tax debt relief process for free by answering a few simple questions.</p>
                      
                        <p className='text-2xl md:text-3xl my-5'><b>Step 2:</b> Have a free consultation with a tax relief expert who will get an IRS tax debt agent on the phone with you.</p>
                        <p className='text-2xl md:text-3xl my-5'><b>Step 3:</b> Learn the best ways to stop IRS collections activities and either get the tax debt forgiven or reduced with a great repayment plan.</p>
                        <p className='text-2xl md:text-3xl my-5'><b>Bonus Step:</b> If you like, for the best results with the least amount of time and frustration, you could even have a tax relief expert take care of your tax debt resolution for you with no out of pocket expense.</p>
                    </div>
                </section> */}
                <section className='py-10 px-5 bg-gray-100'>
                    <div className='max-w-7xl mx-auto' id="start">
                      
                        {/* <h2 className='px-5 py-3 text-center text-gray-900 font-bold md:leading-6 text-4xl mb-5'>Fill Out The Form Below To Get Started</h2>
                        <Calculator /> */}

                        <h2 className='px-5 py-3 text-center text-gray-900 font-bold md:leading-6 text-4xl mb-5'>What People Are Saying</h2>
                        <p className='text-xl italic my-5'>“After numerous attempts to resolve the matter on our own, we went to the Ovation Tax Group
                            and had a great meeting with Ms. Kim. She provided us with a clear path forward and took away all the anxiety from dealing with the issue ourselves.”
                            <br />  <b className='text-2xl not-italic'>– Will Dent</b> </p>
                        <p className='text-xl italic my-5'> “This team is phenomenal! I experienced an unexpected wage garnishment and contacted the team Ovation Tax Group. They are very knowledgeable, professional, and worked extremely fast as well. They resolved my tax issue within 48 hours!“</p>
                    </div>
                </section>
            </main>
        </div>
    );
}

export default LandingPageFour;
